import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_ADD_ATTACHMENT_ITERATION = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ADD_ATTACHMENT_ITERATION`;
export const INTELLIGENT_PHOTO_CAPTURE_ADD_FILE_TO_ITERATION = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ADD_FILE_TO_ITERATION`;
export const INTELLIGENT_PHOTO_CAPTURE_DELETE_ATTACHMENT_ITERATION = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DELETE_ATTACHMENT_ITERATION`;
export const INTELLIGENT_PHOTO_CAPTURE_DELETE_ALL_ATTACHMENT_ITERATIONS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_DELETE_ALL_ATTACHMENT_ITERATIONS`;
export const INTELLIGENT_PHOTO_CAPTURE_ON_TAKE_PHOTO_UPLOAD_SUCCESS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_ON_TAKE_PHOTO_UPLOAD_SUCCESS`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_ATTACHMENT_ITERATION_BATCH_ID = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_ATTACHMENT_ITERATION_BATCH_ID`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_ATTACHMENT_ITERATION_STATUS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_ATTACHMENT_ITERATION_STATUS`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_CAMERA_FILE_STATUS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_CAMERA_FILE_STATUS`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_BATCH_COUNT = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_ITERATION_BATCH_COUNT`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_UPLOADING_STATUS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_ITERATION_UPLOADING_STATUS`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_DAMAGE_CALL_STATUS = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_ITERATION_DAMAGE_CALL_STATUS`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_UPLOAD_FAILED_COUNT = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_ITERATION_UPLOAD_FAILED_COUNT`;
export const INTELLIGENT_PHOTO_CAPTURE_UPDATE_UPLOADED_FILES_COUNT = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_UPDATE_UPLOADED_FILES_COUNT`;
export const photoCaptureIntelligentAddAttachmentIterationAction = (iterationInfo) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ADD_ATTACHMENT_ITERATION,
    payload: { iterationInfo }
});
export const photoCaptureIntelligentUpdateAttachmentIterationStatusAction = (iterationId, iterationStatus) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_ATTACHMENT_ITERATION_STATUS,
    payload: { iterationId, iterationStatus }
});
export const photoCaptureIntelligentUpdateAttachmentIterationBatchIdAction = (iterationId, batchId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_ATTACHMENT_ITERATION_BATCH_ID,
    payload: { iterationId, batchId }
});
export const photoCaptureIntelligentAddFileToIterationAction = (file) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ADD_FILE_TO_ITERATION,
    payload: { file }
});
export const photoCaptureIntelligentUpdateIterationUploadingStatusAction = (iterationId, uploadingStatus) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_UPLOADING_STATUS,
    payload: { iterationId, uploadingStatus }
});
export const photoCaptureIntelligentUpdateIterationDamageCallStatusAction = (iterationId, damageCallStatus, damageProcessStatus) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_DAMAGE_CALL_STATUS,
    payload: { iterationId, damageCallStatus, damageProcessStatus }
});
export const photoCaptureIntelligentUpdateIterationUploadFailedCountAction = (iterationId, uploadFailedCount) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_UPLOAD_FAILED_COUNT,
    payload: { iterationId, uploadFailedCount }
});
export const photoCaptureIntelligentUpdateCameraFileStatusAction = (iterationId, imageName, cameraStatus) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_CAMERA_FILE_STATUS,
    payload: { iterationId, imageName, cameraStatus }
});
export const photoCaptureIntelligentOnTakePhotoUploadSuccessAction = (iterationId, imageName, fileId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_ON_TAKE_PHOTO_UPLOAD_SUCCESS,
    payload: { iterationId, imageName, fileId }
});
export const photoCaptureIntelligentDeleteAttachmentIterationAction = (iterationId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_DELETE_ATTACHMENT_ITERATION,
    payload: { iterationId }
});
export const photoCaptureIntelligentDeleteAllAttachmentIterationsAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_DELETE_ALL_ATTACHMENT_ITERATIONS,
    payload: {}
});
export const photoCaptureIntelligentUpdateUploadedFilesCountAction = (iterationId) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_UPLOADED_FILES_COUNT,
    payload: { iterationId }
});
export const photoCaptureIntelligentUpdateIterationBatchCountAction = (iterationId, batchCount) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_UPDATE_ITERATION_BATCH_COUNT,
    payload: { iterationId, batchCount }
});
//# sourceMappingURL=photoCaptureIntelligentAttachmentIterationInfoAction.js.map